import { EntitiesStore } from "./entities-store.abstract";
import { HttpClient } from "@angular/common/http";
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';


/**
 * Must be implemented for a season statistic.
 *
 * @export
 * @interface SeasonStat
 */
export interface SeasonStat {
  DivCode: string;
  AverageArr: number;
  MatchWinPercentage: number;
}

/**
 * World rank stat element.
 *
 * @export
 * @interface WorldRanking
 */
export interface WorldRanking {
  Cat: string;
  Rnk: number;
}

/**
 * Federation athlete element stored.
 *
 * @export
 * @interface IFederationAthleteStore
 */
export interface IFederationAthleteStore {
  Id: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
  Age: number;
  Gender: string;
  NOC: string;
  SeasonStats: SeasonStat[];
  WorldRankings: WorldRanking[];
  ProfilePicture: string;
}

/**
 * Storage for federation athletes.
 *
 * @export
 * @class FederationAthleteStore
 * @extends {EntitiesStore<IFederationAthleteStore>}
 */
export class FederationAthleteStore extends EntitiesStore<IFederationAthleteStore>{
  constructor(http: HttpClient, injector:Injector) {
    super('ATHLETES', http, [{entity: new CountryDependencyEntityStore(http, injector)}]);
  }
}
